var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"crew-icon"},[_c('div',{staticClass:"initials"},[_vm._v(" "+_vm._s(_vm.user.firstName[0] + _vm.user.lastName[0])+" ")]),_c('div',{staticClass:"tooltip"},[_vm._v(" "+_vm._s(_vm.user.fullName)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }